
import * as __star__ from '@clayui/button';

const {
default: __default__,
ClayButtonWithIcon,
__esModule
} = __star__;

export {
ClayButtonWithIcon,
__esModule
};
export default __default__;
